import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/sti-reverse-scan/icon-sti-dest.svg'
import _imports_1 from '@/app/ui/assets/svg/sti-reverse-scan/icon-sti.svg'
import _imports_2 from '@/app/ui/assets/svg/sti-reverse-scan/icon-pod.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"width":"fit-content"}
}
const _hoisted_3 = { class: "flex flex-row justify-center items-center" }
const _hoisted_4 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: "icon-sti-sti-dest"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  alt: "icon-sti"
}
const _hoisted_7 = {
  key: 2,
  class: "flex flex-col justify-center items-center gap-2"
}
const _hoisted_8 = { class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold" }
const _hoisted_9 = { class: "text-red-lp-500 text-xl font-semibold" }
const _hoisted_10 = {
  key: 0,
  class: "text-red-lp-500 text-xl font-semibold"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"width":"fit-content"}
}
const _hoisted_13 = { class: "flex flex-row justify-center items-center" }
const _hoisted_14 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_15 = {
  key: 0,
  src: _imports_0,
  alt: "icon-sti-sti-dest"
}
const _hoisted_16 = {
  key: 1,
  src: _imports_1,
  alt: "icon-sti"
}
const _hoisted_17 = {
  key: 2,
  class: "flex flex-col justify-center items-center gap-2"
}
const _hoisted_18 = { class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold" }
const _hoisted_19 = { class: "text-red-lp-500 text-xl font-semibold" }
const _hoisted_20 = {
  key: 0,
  class: "text-red-lp-500 text-xl font-semibold"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"width":"fit-content"}
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row justify-center items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: "icon-pod"
  })
], -1)
const _hoisted_24 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_25 = {
  key: 0,
  src: _imports_0,
  alt: "icon-sti-sti-dest"
}
const _hoisted_26 = {
  key: 1,
  src: _imports_1,
  alt: "icon-sti"
}
const _hoisted_27 = {
  key: 2,
  class: "flex flex-col justify-center items-center gap-2"
}
const _hoisted_28 = { class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold" }
const _hoisted_29 = { class: "text-red-lp-500 text-xl font-semibold" }
const _hoisted_30 = {
  key: 0,
  class: "text-red-lp-500 text-xl font-semibold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.flag.toLowerCase().includes('kiriman penting'))
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _ctx.podIconSrc,
                alt: "icon-pod"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_4, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_5))
                : (_openBlock(), _createBlock("img", _hoisted_6)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.regionName), 1),
                    _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('featureName.Kiriman Penting')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.regionName)
              ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('featureName.Kiriman Penting')), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.flag.toLowerCase().includes('lewat batas sla'))
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("img", {
                src: _ctx.podIconSrc,
                alt: "icon-pod"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_14, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_15))
                : (_openBlock(), _createBlock("img", _hoisted_16)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.regionName), 1),
                    _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('featureName.Batas POD Terlewati')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.regionName)
              ? (_openBlock(), _createBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('featureName.Batas POD Terlewati')), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (
      _ctx.flag.toLowerCase().includes('sla hari ini') ||
        _ctx.flag.toLowerCase().includes('delivery ulang')
    )
      ? (_openBlock(), _createBlock("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode("div", _hoisted_24, [
              (_ctx.isStiDest)
                ? (_openBlock(), _createBlock("img", _hoisted_25))
                : (_openBlock(), _createBlock("img", _hoisted_26)),
              (_ctx.regionName)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.regionName), 1),
                    _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('featureName.Batas POD Hari Ini')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.regionName)
              ? (_openBlock(), _createBlock("div", _hoisted_30, _toDisplayString(_ctx.$t('featureName.Batas POD Hari Ini')), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}